
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as config from '../config'
import * as history from '../history'
import * as client from '../client'
import * as feed from '../feed'
import * as storage from '../storage'
import * as exposed from '../exposed'
import * as execution from '../execution'
import * as backup from '../backup'
import * as inner from '../inner'
import * as trade from '../trade'
import * as security from '../security'
import * as document from '../document'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Request} from '../core/Request';
import {FieldModelRequest} from '../core/Request';
import {SymbolSwapSettingsExportResponse} from './SymbolSwapSettingsExportResponse';

/**
 * SymbolSwapSettingsExportRequest struct
 */
class SymbolSwapSettingsExportRequest extends Request {
  /**
   * Initialize struct
   * @param {!Request=} parent
   * @param {!Set=} symbolIds
   * @param {!Set=} symbolGroupIds
   * @constructor
   */
  constructor (parent = new Request(), symbolIds = new Set(), symbolGroupIds = new Set()) {
    super()
    super.copy(parent)
    this.SymbolIds = symbolIds
    this.SymbolGroupIds = symbolGroupIds
  }

  /**
   * Copy struct (shallow copy)
   * @this {!SymbolSwapSettingsExportRequest}
   * @param {!SymbolSwapSettingsExportRequest} other Other struct
   * @returns {!SymbolSwapSettingsExportRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.SymbolIds != null) {
      this.SymbolIds = new Set()
      for (let item of other.SymbolIds) {
        if (item != null) {
          let tempItem
          tempItem = new UUID(item)
          this.SymbolIds.add(tempItem)
        } else {
          this.SymbolIds.add(null)
        }
      }
    } else {
      this.SymbolIds = null
    }
    if (other.SymbolGroupIds != null) {
      this.SymbolGroupIds = new Set()
      for (let item of other.SymbolGroupIds) {
        if (item != null) {
          let tempItem
          tempItem = new UUID(item)
          this.SymbolGroupIds.add(tempItem)
        } else {
          this.SymbolGroupIds.add(null)
        }
      }
    } else {
      this.SymbolGroupIds = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!SymbolSwapSettingsExportRequest}
   * @returns {!SymbolSwapSettingsExportRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new SymbolSwapSettingsExportRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new SymbolSwapSettingsExportRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!SymbolSwapSettingsExportRequest}
   * @param {!SymbolSwapSettingsExportRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof SymbolSwapSettingsExportRequest)) {
      throw new TypeError('Instance of SymbolSwapSettingsExportRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!SymbolSwapSettingsExportRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      SymbolIds: ((this.SymbolIds != null) ? Array.from(this.SymbolIds, item => ((item != null) ? item.toString() : null)) : null),
      SymbolGroupIds: ((this.SymbolGroupIds != null) ? Array.from(this.SymbolGroupIds, item => ((item != null) ? item.toString() : null)) : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return SymbolSwapSettingsExportRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!SymbolSwapSettingsExportRequest} other Object value
   * @returns {!SymbolSwapSettingsExportRequest} Created struct
   */
  static fromObject (other) {
    return new SymbolSwapSettingsExportRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!SymbolSwapSettingsExportRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return SymbolSwapSettingsExportRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!SymbolSwapSettingsExportRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 6639
  }
}

export { SymbolSwapSettingsExportRequest };

/**
 * Fast Binary Encoding SymbolSwapSettingsExportRequest field model
 */
class FieldModelSymbolSwapSettingsExportRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelRequest(buffer, 4 + 4)
    this.SymbolIds = new fbe.FieldModelSet(new fbe.FieldModelUUID(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.SymbolGroupIds = new fbe.FieldModelSet(new fbe.FieldModelUUID(buffer, this.SymbolIds.fbeOffset + this.SymbolIds.fbeSize), buffer, this.SymbolIds.fbeOffset + this.SymbolIds.fbeSize)
  }

  /**
   * Get the core.Request field model
   * @this {!FieldModelSymbolSwapSettingsExportRequest}
   * @returns {!FieldModelRequest} core.Request field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelSymbolSwapSettingsExportRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelSymbolSwapSettingsExportRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.SymbolIds.fbeSize + this.SymbolGroupIds.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelSymbolSwapSettingsExportRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.SymbolIds.fbeExtra + this.SymbolGroupIds.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelSymbolSwapSettingsExportRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelSymbolSwapSettingsExportRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelSymbolSwapSettingsExportRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 6639
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelSymbolSwapSettingsExportRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelSymbolSwapSettingsExportRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.SymbolIds.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SymbolIds.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolIds.fbeSize

    if ((fbeCurrentSize + this.SymbolGroupIds.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SymbolGroupIds.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolGroupIds.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelSymbolSwapSettingsExportRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelSymbolSwapSettingsExportRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelSymbolSwapSettingsExportRequest}
   * @param {!SymbolSwapSettingsExportRequest} fbeValue Default value, defaults is new SymbolSwapSettingsExportRequest()
   * @returns {!SymbolSwapSettingsExportRequest} SymbolSwapSettingsExportRequest value
   */
  get (fbeValue = new SymbolSwapSettingsExportRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelSymbolSwapSettingsExportRequest}
   * @param {!SymbolSwapSettingsExportRequest} fbeValue SymbolSwapSettingsExportRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.SymbolIds.fbeSize) <= fbeStructSize) {
      this.SymbolIds.get(fbeValue.SymbolIds)
    } else {
      fbeValue.SymbolIds.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolIds.fbeSize

    if ((fbeCurrentSize + this.SymbolGroupIds.fbeSize) <= fbeStructSize) {
      this.SymbolGroupIds.get(fbeValue.SymbolGroupIds)
    } else {
      fbeValue.SymbolGroupIds.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolGroupIds.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelSymbolSwapSettingsExportRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelSymbolSwapSettingsExportRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelSymbolSwapSettingsExportRequest}
   * @param {!SymbolSwapSettingsExportRequest} fbeValue SymbolSwapSettingsExportRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelSymbolSwapSettingsExportRequest}
   * @param {SymbolSwapSettingsExportRequest} fbeValue SymbolSwapSettingsExportRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.SymbolIds.set(fbeValue.SymbolIds)
    this.SymbolGroupIds.set(fbeValue.SymbolGroupIds)
  }
}

export { FieldModelSymbolSwapSettingsExportRequest };

/**
 * Fast Binary Encoding SymbolSwapSettingsExportRequest model
 */
class SymbolSwapSettingsExportRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelSymbolSwapSettingsExportRequest(this.buffer, 4)
  }

  /**
   * Get the SymbolSwapSettingsExportRequest model
   * @this {!SymbolSwapSettingsExportRequestModel}
   * @returns {!FieldModelSymbolSwapSettingsExportRequest} model SymbolSwapSettingsExportRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!SymbolSwapSettingsExportRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!SymbolSwapSettingsExportRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return SymbolSwapSettingsExportRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!SymbolSwapSettingsExportRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelSymbolSwapSettingsExportRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!SymbolSwapSettingsExportRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!SymbolSwapSettingsExportRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!SymbolSwapSettingsExportRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!SymbolSwapSettingsExportRequestModel}
   * @param {!SymbolSwapSettingsExportRequest} value SymbolSwapSettingsExportRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!SymbolSwapSettingsExportRequestModel}
   * @param {!SymbolSwapSettingsExportRequest} value SymbolSwapSettingsExportRequest value, defaults is new SymbolSwapSettingsExportRequest()
   * @return {!object} Deserialized SymbolSwapSettingsExportRequest value and its size
   */
  deserialize (value = new SymbolSwapSettingsExportRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new SymbolSwapSettingsExportRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new SymbolSwapSettingsExportRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!SymbolSwapSettingsExportRequestModel}
   * @param {!number} prev Previous SymbolSwapSettingsExportRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { SymbolSwapSettingsExportRequestModel };
SymbolSwapSettingsExportRequest.__has_response = true;
SymbolSwapSettingsExportRequest.__response_class = SymbolSwapSettingsExportResponse;
